/* Jump to ONE specific product image when variant changes
   Target image must have alt="jump-on-variant"
*/
(function () {
  const TARGET_ALT = 'jump-on-variant';

  function findAndClickThumbnail() {
    const imgs = Array.from(document.querySelectorAll('img[alt]'));
    const targetImg = imgs.find(img =>
      (img.getAttribute('alt') || '').trim().toLowerCase() === TARGET_ALT
    );

    if (!targetImg) {
      console.warn('[jump-on-variant] image not found');
      return;
    }

    // Click the closest clickable parent
    const clickable =
      targetImg.closest('button') ||
      targetImg.closest('a') ||
      targetImg.closest('li') ||
      targetImg.closest('div');

    if (!clickable) {
      console.warn('[jump-on-variant] no clickable parent found');
      return;
    }

    clickable.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    clickable.click();
  }

  // Fire on any variant change
  document.addEventListener('change', (e) => {
    if (!e.target.closest('[name^="Color"], [name^="option"], .variant-input')) return;
    setTimeout(findAndClickThumbnail, 50);
  });

  // Manual debug helper
  window.jumpToVariantImage = findAndClickThumbnail;
})();

(function () {
  const PROTECTION_VARIANT_ID = 54852027220344;
  const TOGGLE_SELECTOR = '[data-cart-protection-toggle]';
  const STYLE_ID = 'cart-protection-toggle-styles';
  const observedRoots = new WeakSet();
  let injectTimer = null;

  const protectionStyles = `
    .cart-protection-toggle {
      width: 100%;
      margin: 4px 0 8px;
      padding: 8px 0 11px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
      position: relative;
      border: 0;
      border-radius: 0;
      background: transparent;
      color: #253963;
      text-align: left;
      cursor: pointer;
      box-sizing: border-box;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      -webkit-appearance: none;
      appearance: none;
    }

    .cart-protection-toggle::before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 1px;
      background: rgba(37, 57, 99, 0.24);
      pointer-events: none;
    }

    .cart-protection-toggle__icon {
      width: 24px;
      height: 28px;
      flex: 0 0 24px;
      color: #090909;
    }

    .cart-protection-toggle__icon svg {
      display: block;
      width: 100%;
      height: 100%;
    }

    .cart-protection-toggle__text {
      min-width: 0;
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 2px;
    }

    .cart-protection-toggle__title {
      display: block;
      color: #000;
      font-size: 14px;
      font-weight: 700;
      line-height: 1.12;
    }

    .cart-protection-toggle__description {
      display: block;
      color: #424b5c;
      font-size: 11.5px;
      font-weight: 400;
      line-height: 1.2;
    }

    .cart-protection-toggle__switch {
      position: relative;
      width: 20px;
      height: 20px;
      flex: 0 0 20px;
      border: 2px solid #b9cde0;
      border-radius: 4px;
      background: #fff;
      box-sizing: border-box;
      transition: background 0.2s ease, border-color 0.2s ease;
    }

    .cart-protection-toggle__switch::after {
      content: "";
      position: absolute;
      left: 4px;
      top: 1px;
      width: 6px;
      height: 10px;
      border: solid #fff;
      border-width: 0 3px 3px 0;
      opacity: 0;
      transform: rotate(45deg);
      transition: opacity 0.2s ease;
    }

    .cart-protection-toggle__knob {
      display: none;
    }

    .cart-protection-toggle[aria-pressed="true"] .cart-protection-toggle__switch {
      background: #0b98d8;
      border-color: #0b98d8;
    }

    .cart-protection-toggle[aria-pressed="true"] .cart-protection-toggle__switch::after {
      opacity: 1;
    }

    .cart-protection-toggle.is-loading {
      cursor: wait;
      opacity: 0.65;
    }
  `;

  function getCart() {
    return cartRequest('/cart.js');
  }

  function cartRequest(url, options) {
    options = options || {};

    if (window.fetch) {
      return fetch(url, Object.assign({
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      }, options)).then(response => response.json());
    }

    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open(options.method || 'GET', url, true);
      request.withCredentials = true;
      request.setRequestHeader('Accept', 'application/json');

      if (options.headers) {
        Object.keys(options.headers).forEach(key => {
          request.setRequestHeader(key, options.headers[key]);
        });
      }

      request.onload = () => {
        try {
          resolve(JSON.parse(request.responseText));
        } catch (error) {
          reject(error);
        }
      };
      request.onerror = reject;
      request.send(options.body || null);
    });
  }

  function setProtectionQuantity(quantity) {
    return cartRequest('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        updates: {
          [PROTECTION_VARIANT_ID]: quantity
        }
      })
    });
  }

  function addProtection() {
    return setProtectionQuantity(1);
  }

  function hasProtection(cart) {
    return cart.items.some(item => Number(item.variant_id) === PROTECTION_VARIANT_ID && item.quantity > 0);
  }

  function getRoots() {
    const roots = [document];

    document.querySelectorAll('#opus-shadow-container').forEach(host => {
      if (host.shadowRoot) roots.push(host.shadowRoot);
    });

    return roots;
  }

  function injectStyle(root) {
    if (root.querySelector(`#${STYLE_ID}`)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = protectionStyles;

    if (root === document) {
      document.head.appendChild(style);
    } else {
      root.appendChild(style);
    }
  }

  function createCard() {
    const card = document.createElement('button');
    card.type = 'button';
    card.className = 'cart-protection-toggle';
    card.setAttribute('data-cart-protection-toggle', '');
    card.setAttribute('data-variant-id', String(PROTECTION_VARIANT_ID));
    card.setAttribute('aria-pressed', 'false');
    card.innerHTML = `
      <span class="cart-protection-toggle__switch" aria-hidden="true">
        <span class="cart-protection-toggle__knob"></span>
      </span>
      <span class="cart-protection-toggle__icon" aria-hidden="true">
        <svg viewBox="0 0 24 29" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.58 1.5L21.58 5.6V12.1C21.58 18.7 17.43 24.76 11.58 27C5.73 24.76 1.58 18.7 1.58 12.1V5.6L11.58 1.5Z" stroke="currentColor" stroke-width="2.6" stroke-linejoin="round"/>
          <path d="M7.15 13.92L10.18 16.95L16.22 9.7" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span class="cart-protection-toggle__text">
        <span class="cart-protection-toggle__title">Pakke forsikring &amp; ekspress levering</span>
        <span class="cart-protection-toggle__description">Beskyttelse mod skader, tab, tyveri og mere!</span>
      </span>
    `;
    card.addEventListener('click', handleToggleClick);
    return card;
  }

  function findCheckoutTarget(root) {
    const elements = Array.from(root.querySelectorAll('button, a, [role="button"], .opus-btn-checkout, .opus-checkout-btn-2'));

    return elements.find(element => {
      const text = (element.innerText || element.textContent || '').trim().toLowerCase();
      const classes = String(element.className || '').toLowerCase();

      return text.includes('gå til betaling') ||
        text.includes('checkout') ||
        classes.includes('opus-btn-checkout') ||
        classes.includes('opus-checkout-btn');
    });
  }

  function getInsertTarget(checkoutTarget) {
    return checkoutTarget.closest('.opus-btn-checkout, .opus-checkout-btn-2, button, a, [role="button"]') || checkoutTarget;
  }

  function getOpusFooter(root) {
    const target = root.querySelector('.bottom-section');

    if (!target) return null;

    return target;
  }

  function updateToggle(toggle, enabled) {
    toggle.setAttribute('aria-pressed', enabled ? 'true' : 'false');
  }

  function syncToggles(cart) {
    const update = currentCart => {
      getRoots().forEach(root => {
        root.querySelectorAll(TOGGLE_SELECTOR).forEach(toggle => {
          updateToggle(toggle, hasProtection(currentCart));
        });
      });
    };

    if (cart) {
      update(cart);
      return;
    }

    getCart().then(update).catch(() => {});
  }

  function refreshCartDrawer(cart) {
    const eventDetail = { cart: cart };

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: eventDetail }));
    document.dispatchEvent(new CustomEvent('cart:build', { detail: eventDetail }));
    document.dispatchEvent(new CustomEvent('OpusCartChange', { detail: eventDetail }));
    window.dispatchEvent(new CustomEvent('OpusCartChange', { detail: eventDetail }));
    window.dispatchEvent(new CustomEvent('OpusSetCartData', { detail: eventDetail }));
    document.dispatchEvent(new CustomEvent('OpusSetCartData', { detail: eventDetail }));
    document.dispatchEvent(new CustomEvent('OpusAddToCartComplete', { detail: eventDetail }));
    window.dispatchEvent(new CustomEvent('OpusAddToCartComplete', { detail: eventDetail }));
  }

  function handleToggleClick(event) {
    const toggle = event.currentTarget;

    if (!toggle || toggle.classList.contains('is-loading')) return;

    const shouldEnable = toggle.getAttribute('aria-pressed') !== 'true';

    toggle.classList.add('is-loading');
    toggle.disabled = true;

    const request = shouldEnable ? addProtection() : setProtectionQuantity(0);

    request
      .then(() => getCart())
      .then(cart => {
        updateToggle(toggle, shouldEnable);
        refreshCartDrawer(cart);
      })
      .catch(error => {
        console.warn('[cart-protection-toggle] update failed', error);
        syncToggles();
      })
      .finally(() => {
        toggle.classList.remove('is-loading');
        toggle.disabled = false;
      });
  }

  function ensureProtectionCard() {
    getRoots().forEach(root => {
      injectStyle(root);
      observeRoot(root);

      if (root.querySelector(TOGGLE_SELECTOR)) return;

      const checkoutTarget = findCheckoutTarget(root);
      if (!checkoutTarget) return;

      const opusFooter = getOpusFooter(root);
      if (opusFooter) {
        opusFooter.insertBefore(createCard(), opusFooter.firstChild);
        return;
      }

      const insertTarget = getInsertTarget(checkoutTarget);
      if (!insertTarget || !insertTarget.parentNode) return;

      insertTarget.parentNode.insertBefore(createCard(), insertTarget);
    });
  }

  function scheduleEnsureProtectionCard() {
    window.clearTimeout(injectTimer);
    injectTimer = window.setTimeout(ensureProtectionCard, 100);
  }

  function observeRoot(root) {
    if (!root || observedRoots.has(root)) return;

    observedRoots.add(root);

    new MutationObserver(scheduleEnsureProtectionCard).observe(root === document ? document.body : root, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('cart:updated', event => syncToggles(event.detail && event.detail.cart));
  document.addEventListener('cart:build', () => scheduleEnsureProtectionCard());
  document.addEventListener('DOMContentLoaded', scheduleEnsureProtectionCard);
  window.addEventListener('load', scheduleEnsureProtectionCard);

  observeRoot(document);
  scheduleEnsureProtectionCard();
  window.setTimeout(scheduleEnsureProtectionCard, 1000);
  window.setTimeout(scheduleEnsureProtectionCard, 3000);
})();
